import React, { useContext, useEffect, useReducer } from "react";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  // getConfigValues,
  GetMemberDashboardDetails,
} from "../../Helpers/APIEndPoints/EndPoints";
import "./SanjivanSuvidha.css";

const SanjivaniYojna = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const [sanjeevanDesc, setSanjeevanDesc] = React.useState<string>("");
  let navigate = useNavigate();
  const { appModule, sanjeevanDesc } = props;
  const [forceUpdate] = useReducer((x) => x + 1, 0);
  const context = getContext();
  let MemberId = context.MemberId;

  //get static data from backend
  // const callConfigData = async () => {
  //   showLoader();
  //   const config = ["SanjeevaniYojnaDescription"];

  //   const result = await APICall(getConfigValues, { Keys: config });

  //   if (result && result.Message == "Ok" && result.Data.length > 0) {
  //     hideLoader();
  //     let desc = result.Data.find(
  //       (cd) => cd.Key === "SanjeevaniYojnaDescription"
  //     );
  //     if (desc) {
  //       setSanjeevanDesc(desc.Value);
  //     }
  //   }
  //   hideLoader();
  // };

  // const getDashboardData = async () => {
  //   showLoader();
  //   try {
  //     const obj = { MemberId };
  //     const resp = await APICall(GetMemberDashboardDetails, obj);

  //     const memberData = resp?.Data;
  //     setSanjeevanDesc(memberData?.Description_Sanjivani);
  //     forceUpdate();
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  // useEffect(() => {
  //   // callConfigData();
  //   if (MemberId) {
  //     getDashboardData();
  //   }
  // }, [MemberId]);

  // Navigate page click on apply button
  const handleApplyNowClick = () => {
    const YojnaType = "SanjivaniYojna";
    navigate("/SanjivaniMenu", { state: { YojnaType, appModule } });
  };

  return (
    <div className="my-card set-bgimg-san">
      <h4 className="font-weight-bold text-center mb-3">Sanjivani Yojna</h4>
      <p>{sanjeevanDesc}</p>
      <div className="red_btn text-center mt-3">
        <button
          className="text-center btn-submit"
          onClick={handleApplyNowClick}
        >
          <i className="fas fa-check"></i> Apply Now
        </button>{" "}
      </div>
    </div>
  );
};

export default SanjivaniYojna;
